module.exports = __webpack_public_path__ + "media/img/pay-1-735e3a37b7a082364742c033495cc126.svg";